/*global swal*/
import './style.less';
import { keyBy, sortBy, get } from 'lodash';

export default function($scope, $log, $stateParams, $q, CategoryClass, ProfileClass, ApiClass) {
  'ngInject';
  $scope.profile_uid = $stateParams.id;
  $scope.loaded = false;

  const qArr = [
    CategoryClass.loadCategories(),
    ProfileClass.profileComplete,
    ApiClass.coursesGet(
      {
        courseType: 'internal'
      },
      {},
      { queryParams: { manage: true, 'filter:basic': true } }
    )
  ];

  $q.all(qArr)
    .then(([categories, profileComplete, coursesReponse]) => {
      const courses = coursesReponse.data.courses;
      $scope.courses = sortBy(courses, 'name');
      $scope.course_dict = keyBy('event_id', courses);
      $scope.Categories = categories.obj;
      $scope.tooltipMsg = { true: 'This course is active, it can be taken by users. Click to deactivate course.' };
      $scope.tooltipMsg.false = 'This course is not active, it can not be taken by users. Click to activate course.';

      $scope.coursesReview = $scope.courses.filter(
        ({ adminReview, submitted, active }) => adminReview && submitted && !active
      );

      $scope.disableButtons = get(profileComplete, 'company.preferences.read_only.admin.courseReview', false);
      $scope.loaded = true;
    })
    .catch(error => {
      $scope.loaded = true;
      $scope.error.status = true;
      $log.error(error);
      throw error;
    });
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/courses/approval/index.js